/** @prettier */

/**
 * CSVフォーマットエラーのダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Box,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
//Style import
import '../css/common/common.css';
import {PrimaryButton} from '../component/BasicButton';

/**
 * CSVフォーマットエラーダイアログ
 * @param props props
 * @returns JSX
 * - open ダイアログを開く変数
 * - setOpen openのセット関数
 * - id ID
 */
const CSVFormatErrorMessage = (props: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  errorMessage: {errorCode: string; parameter: string[] | []};
  id?: string;
}) => {
  const trans = useTranslation().t; //翻訳関数
  /**
   * OKボタン押下時処理
   */
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      className="csvFormatErrorDialog">
      <DialogTitle
        id="form-dialog-title"
        className="csvFormatErrorDialog__title">
        {trans('CSVFormatErrorMessage.title')}
      </DialogTitle>
      <DialogContent>
        {/* ダイアログに表示するメッセージ */}
        <DialogContentText>
          <Box component="span" className="csvFormatErrorDialog__text">
            {trans('CSVFormatErrorMessage.message.fileError')}
          </Box>
        </DialogContentText>
        <List dense className="csvFormatErrorDialog__text">
          {props.errorMessage.parameter.map((item, index) => {
            return (
              <ListItem key={index}>
                <ListItemText primary={`- ${item}`} />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={handleClose}
          buttonText={trans('CSVFormatErrorMessage.buttonTxt.ok')}
          id={props.id}
        />
      </DialogActions>
    </Dialog>
  );
};
export default CSVFormatErrorMessage;
